/** @format */

import LandingPage from "pages/LandingPage/LandingPage";
import React from "react";

function App(): any {
	return <LandingPage></LandingPage>;
}

export default App;
